module.exports = __webpack_public_path__ + "img/corona1.ed3176ac.jpeg";